export default __webpack_public_path__ + "static/media/profilepage-editInfo.da37ec07.svg";